import React from 'react';
import { Redirect } from 'react-router';
import unleash from '../unleash';

export function withMaintenanceRedirect(toggleName, redirectPath = '/') {
  return (DecoratedComponent) => (props) => {
    if (unleash.isEnabled(toggleName)) {
      return <Redirect to={redirectPath} />;
    }

    return <DecoratedComponent {...props} />;
  };
}
